import React, { useCallback, useEffect, useState } from 'react';
import { Star } from 'lucide-react';
import { testimonials } from '../mock';
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';

const TestimonialsSection = () => {
  const [emblaRef, emblaApi] = useEmblaCarousel(
    { loop: true, align: 'start', slidesToScroll: 1 },
    [Autoplay({ delay: 3500, stopOnInteraction: false })]
  );
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [scrollSnaps, setScrollSnaps] = useState([]);

  useEffect(() => {
    if (!emblaApi) return;
    setScrollSnaps(emblaApi.scrollSnapList());
    const onSelect = () => setSelectedIndex(emblaApi.selectedScrollSnap());
    emblaApi.on('select', onSelect);
    onSelect();
    return () => emblaApi.off('select', onSelect);
  }, [emblaApi]);

  return (
    <section className="py-24 bg-[#EAE7DF]" data-testid="home-testimonials-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <p className="eyebrow mb-4">Client Testimonials</p>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-[#111C16] tracking-tighter">Trusted by businesses nationwide</h2>
        </div>

        <div className="relative">
          {/* Carousel */}
          <div className="overflow-hidden" ref={emblaRef}>
            <div className="flex gap-6">
              {testimonials.slice(0, 6).map((t) => (
                <div key={t.id} className="flex-[0_0_100%] md:flex-[0_0_calc(50%-12px)] lg:flex-[0_0_calc(33.333%-16px)] min-w-0">
                  <div className="bg-white rounded-3xl p-8 border border-[#D5D1C8] h-full" data-testid={`testimonial-card-${t.id}`} style={{ marginLeft: t.id === 1 ? '24px' : '0' }}>
                    <div className="flex space-x-1 mb-4">{[...Array(5)].map((_, i) => <Star key={i} className="h-3.5 w-3.5 fill-[#C85A40] text-[#C85A40]" />)}</div>
                    <p className="font-body text-sm text-[#4A5D53] mb-6 leading-relaxed">"{t.content}"</p>
                    <div className="flex items-center space-x-3 pt-4 border-t border-[#D5D1C8]">
                      <img src={t.image} alt={t.name} className="w-10 h-10 rounded-full object-cover" />
                      <div>
                        <h4 className="font-display text-sm font-medium text-[#111C16]">{t.name}</h4>
                        <p className="font-body text-xs text-[#4A5D53]">{t.role}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-10" data-testid="testimonial-dots">
            {scrollSnaps.map((_, i) => (
              <button
                key={i}
                onClick={() => emblaApi?.scrollTo(i)}
                className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${i === selectedIndex ? 'bg-[#C85A40] w-7' : 'bg-[#D5D1C8]'}`}
                aria-label={`Go to slide ${i + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
